import Image from 'next/image';
import React, { forwardRef } from 'react';

import { t } from '@/utils/helper/intl';

import RingIcon from './icon/ring';
export interface UploadReadyProps {
  className?: string;
  text?: string;
  detail?: React.ReactNode;
  slotNode?: React.ReactNode | ((ref: React.Ref<HTMLDivElement>) => React.ReactNode);
  tip?: string;
}

const UploadReady = forwardRef<HTMLDivElement, UploadReadyProps>(
  (props, ref): React.ReactNode => {
    const { className = '', text, detail, slotNode, tip } = props;
    if (typeof slotNode === 'function') {
      return slotNode(ref);
    }
    if (slotNode) {
      return slotNode;
    }

    return (
      <div
        ref={ref}
        className={`dragger-upload-ready h-full flex items-center flex-col rounded-[8px] py-[60px] relative ${className}`}
      >
        {tip ? (
          <div
            className="text-[12px] text-common-text-base-color tracking-[0.32px] w-full h-[22px] flex justify-center items-center absolute top-0 left-0"
            style={{
              borderRadius: '4px 4px 0 0',
              background:
                'linear-gradient(0deg, rgba(4, 14, 121, 0.00) -100%, rgba(62, 62, 236, 0.20) 100%)',
            }}
          >
            <RingIcon className="text-common-text-base-color" />
            &nbsp; {tip}
          </div>
        ) : null}
        <div className="py-[20px] px-[12px]">
          <Image src="/images/fileIcon.png" width={96} height={79} alt="" />
        </div>

        <p className="text-[18px] font-[700] leading-[32px] tracking-[0.36px]">
          {text || t('bc.upload')}
        </p>
        <div className="text-common-modal-upload-popover-text-color text-[12px] font-medium tracking-[0.5px] pt-[10px]">
          {detail}
        </div>
      </div>
    );
  },
);

export default UploadReady;
